export default "__VITE_ASSET__98VCvnVc__"